export default "__VITE_ASSET__D1e9GKnH__"